export const FETCH_LEAVE_REQUESTS_REQUEST = "FETCH_LEAVE_REQUESTS_REQUEST";
export const FETCH_LEAVE_REQUESTS_SUCCESS = "FETCH_LEAVE_REQUESTS_SUCCESS";
export const FETCH_LEAVE_REQUESTS_FAIL = "FETCH_LEAVE_REQUESTS_FAIL";